export const selectLocations = (state) => state?.locationReducer?.items;
export const selectTotalRowCounts = (state) =>
  state?.locationReducer?.totalRowsCount;
export const selectLoading = (state) => state?.locationReducer?.loading;
export const selectStatus = (state) => state?.locationReducer?.status;
export const selectError = (state) => state.locationReducer.error;
export const selectSelectedItem = (state) =>
  state?.medicineReducer?.selectedItem;
export const getLocationsForDropdown = (state) => state?.locationReducer?.locationsForDropdown;